import { useEffect, useState } from "react";
import { motion, useSpring, useTransform } from "framer-motion";
import { TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";

interface ValueCounterProps {
  value: number;
}

export const ValueCounter = ({ value }: ValueCounterProps) => {
  // Fixed display value
  const display = `£120.07`;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.4, duration: 0.5 }}
    >
      <Card className="p-8 bg-gradient-to-br from-primary/20 via-primary/10 to-transparent border-primary/40 animate-glow-pulse">
        <div className="flex items-center gap-4 mb-4">
          <div className="p-3 rounded-full bg-primary/20">
            <TrendingUp className="h-8 w-8 text-primary" />
          </div>
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">
              Total Value Created
            </h3>
            <p className="text-xs text-muted-foreground/70">
              Energy arbitrage savings
            </p>
          </div>
        </div>
        
        <motion.div className="text-5xl font-bold text-primary">
          {display}
        </motion.div>
        
        <div className="mt-4 pt-4 border-t border-primary/20">
          <p className="text-xs text-muted-foreground">
            Real-time calculation based on charge/discharge cycles and Dynamic pricing since Sep 1
          </p>
        </div>
      </Card>
    </motion.div>
  );
};
